function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_03",
  transform: "translate(0 -424)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Box",
  transform: "translate(0 424)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1,
  opacity: 0
}, /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 376,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 639,
  height: 375,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vereinigungsmenge_6",
  "data-name": "Vereinigungsmenge 6",
  transform: "translate(-1622 -463)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 1994.992309570312 1146.000366210938 L 1907.00732421875 1146.000366210938 C 1907.005004882812 1146.000366210938 1907.002807617188 1146.000366210938 1907.00048828125 1146.000366210938 L 1907.00048828125 1076.613891601562 L 1907.02392578125 1076.475708007812 L 1907.01611328125 1076.183959960938 C 1907.005737304688 1075.790771484375 1907.00048828125 1075.392333984375 1907.00048828125 1074.999633789062 C 1907.00048828125 1069.058471679688 1908.163452148438 1063.296508789062 1910.456909179688 1057.8740234375 C 1912.6728515625 1052.634887695312 1915.845703125 1047.929077148438 1919.887573242188 1043.88720703125 C 1923.929321289062 1039.845336914062 1928.635131835938 1036.67236328125 1933.874267578125 1034.456420898438 C 1939.296875 1032.162841796875 1945.058837890625 1030.999877929688 1951.000244140625 1030.999877929688 C 1956.94140625 1030.999877929688 1962.703247070312 1032.162841796875 1968.125854492188 1034.456420898438 C 1973.364990234375 1036.67236328125 1978.07080078125 1039.845336914062 1982.112670898438 1043.88720703125 C 1986.154541015625 1047.929077148438 1989.327514648438 1052.634887695312 1991.54345703125 1057.8740234375 C 1993.837036132812 1063.296630859375 1995 1069.058471679688 1995 1074.999633789062 C 1995 1075.391845703125 1994.994750976562 1075.790283203125 1994.984375 1076.183959960938 L 1994.9765625 1076.475708007812 L 1995 1076.614013671875 L 1995 1146.000366210938 C 1994.997436523438 1146.000366210938 1994.994873046875 1146.000366210938 1994.992309570312 1146.000366210938 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1992.00390625 1143.000366210938 L 1992.067260742188 1077.263549804688 L 1991.969970703125 1076.688110351562 L 1991.9853515625 1076.104736328125 L 1992 1074.999633789062 C 1992 1052.392333984375 1973.607543945312 1033.999877929688 1951.000244140625 1033.999877929688 C 1928.392944335938 1033.999877929688 1910.00048828125 1052.392333984375 1910.00048828125 1074.999633789062 L 1910.00048828125 1076.463012695312 L 1910.00048828125 1143.000366210938 L 1992.00390625 1143.000366210938 M 1994.992309570312 1149.000366210938 L 1907.00732421875 1149.000366210938 C 1905.346801757812 1149.000366210938 1904.00048828125 1148.1552734375 1904.00048828125 1147.112182617188 L 1904.00048828125 1076.463012695312 C 1904.00048828125 1076.3955078125 1904.006103515625 1076.328857421875 1904.017211914062 1076.26318359375 C 1904.006103515625 1075.842895507812 1904.00048828125 1075.422607421875 1904.00048828125 1074.999633789062 C 1904.00048828125 1049.042724609375 1925.04248046875 1027.999877929688 1951.000244140625 1027.999877929688 C 1976.957153320312 1027.999877929688 1998 1049.042724609375 1998 1074.999633789062 C 1998 1075.422607421875 1997.994384765625 1075.842895507812 1997.983276367188 1076.26318359375 C 1997.994384765625 1076.328857421875 1998 1076.3955078125 1998 1076.463012695312 L 1998 1147.112182617188 C 1998 1148.1552734375 1996.653686523438 1149.000366210938 1994.992309570312 1149.000366210938 Z",
  stroke: "none",
  fill: "#333330"
})), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_16",
  "data-name": "Pfad 16",
  d: "M0-1.112V69.537c0,1.043,1.5,1.888,3.36,1.888H101.64c1.856,0,3.36-.845,3.36-1.888V-1.112C105-2.155,103.5-3,101.64-3H3.36C1.5-3,0-2.155,0-1.112Z",
  transform: "translate(276 642.576)",
  fill: "#fff",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  transform: "translate(319 657)",
  fill: "#333330",
  stroke: "#333330",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_61",
  "data-name": "Rechteck 61",
  transform: "translate(323 666)",
  fill: "#333330",
  stroke: "#333330",
  strokeLinejoin: "round",
  strokeWidth: 6
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 29,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 6,
  height: 23,
  fill: "none"
})));

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 376,
    viewBox: "0 0 640 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ad6e7e7a674081bb581d1d9b7583815d.svg";
export { ForwardRef as ReactComponent };